const formControlLabelFormParamUser = {
  admin: 'Administrador',
  analyst: 'Analista',
  contractor: 'Tercera empresa'
};

export default formControlLabelFormParamUser;
